import React from "react";
import {useTranslate} from "@tolgee/react";
import useStyles from "./styles";

export function useFrillWidget() {
  const widgetRef = React.useRef<FrillWidget | null>(null);

  React.useEffect(() => {
    // This is an async function, but we're not going to use the resolved result directly,
    // instead we assign the promise to a variable so we can destroy it in the hook cleanup.
    const widget = window.Frill("widget", {
      // Put your Widget key here
      key: "df1eec20-f5f4-422e-b551-7d9e3eeef2ad",
      callbacks: {
        onReady(widget) {
          widgetRef.current = widget;
          // You can subscribe to widget events like so, don't forget to unsubscribe though.
          // const unsubscribe = widgetRef.current.events.on('badgeCount', console.log)
        },
      },
    });

    return () => {
      widgetRef.current = null;
      // Calling destroy will also remove the widget from the DOM
      widget.destroy();
    };
  }, []);

  return widgetRef;
}

const MyFrillWidget: React.FC = React.memo(() => {
  const classes = useStyles();
  const {t} = useTranslate();
  const widgetRef = useFrillWidget();

  return (
    <button
      type="button"
      className={`my-frill-widget ${classes.cta}`}
      onClick={() => {
        widgetRef.current?.open();
      }}
    >
      {t("common.nav.feature_request")}
    </button>
  );
});

export default MyFrillWidget;
